"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupBackgroundTasks = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const service_1 = __importDefault(require("./services/userMgmt/service"));
const chatFunctions = __importStar(require("./domain/model/chats"));
const setFunctions = __importStar(require("./utils/setFunctions"));
const stateFunctions = __importStar(require("./domain/stateFunctions"));
const RecurringTaskRunner_1 = __importDefault(require("./domain/RecurringTaskRunner"));
const RtcConnectionsHandler_1 = __importDefault(require("./domain/webRtc/RtcConnectionsHandler"));
const ExponentialBackoffRecurringTaskRunner_1 = __importStar(require("./domain/ExponentialBackoffRecurringTaskRunner"));
const ChatsUpdater_1 = __importDefault(require("./domain/ChatsUpdater"));
const getAllChats_1 = __importDefault(require("./actions/chats/getAllChats"));
const getMessagesById_1 = __importDefault(require("./actions/chats/getMessagesById"));
const getUsers_1 = __importDefault(require("./actions/users/getUsers"));
const updateMinutesSinceLastOnline_1 = __importDefault(require("./actions/users/updateMinutesSinceLastOnline"));
const CachingDataService_1 = __importDefault(require("./services/data/CachingDataService"));
const constants_1 = require("./constants");
function setupBackgroundTasks() {
    var _a, _b, _c;
    const dispatch = react_redux_1.useDispatch();
    const chatsState = react_redux_1.useSelector((state) => state.chatsState);
    const usersState = react_redux_1.useSelector((state) => state.usersState);
    const sessionExpired = react_redux_1.useSelector((state) => state.appState.sessionExpired);
    const selectedChat = stateFunctions.getSelectedChat(chatsState);
    const selectedChatUsers = selectedChat ? chatFunctions.getUsers(selectedChat) : [];
    const usersOnline = Object.values(usersState.userDictionary)
        .filter(u => u.minutesSinceLastOnline < 2)
        .map(u => u.userId);
    const selectedChatUsersOnline = setFunctions.intersect(selectedChatUsers, usersOnline);
    react_1.useEffect(() => {
        const count = sessionExpired ? 0 : chatFunctions.getUnreadChatCount(chatsState.chats);
        document.title = (count > 0 ? `(${count}) ` : "") + constants_1.APP_TITLE;
    }, [chatsState.chats, sessionExpired]);
    // Each time 'usersState.me' changes and is not null, get the full list of chats
    react_1.useEffect(() => {
        var _a;
        if (((_a = usersState.me) === null || _a === void 0 ? void 0 : _a.userId) && !sessionExpired) {
            dispatch(getAllChats_1.default());
        }
    }, [(_a = usersState.me) === null || _a === void 0 ? void 0 : _a.userId, sessionExpired]);
    // As new userIds are seen, fetch their usernames
    react_1.useEffect(() => {
        if (usersState.unknownUserIds.length && !sessionExpired) {
            dispatch(getUsers_1.default(usersState.unknownUserIds));
        }
    }, [usersState.unknownUserIds, sessionExpired]);
    // Whenever a chat has messages to download, call off to get those messages
    react_1.useEffect(() => {
        if (!sessionExpired) {
            chatsState.chats.forEach(c => {
                if (chatFunctions.isConfirmedChat(c) && c.messagesToDownload.length && !c.messagesDownloading.length) {
                    dispatch(getMessagesById_1.default(c.chatId, c.messagesToDownload.slice(0, constants_1.PAGE_SIZE)));
                }
            });
        }
    }, [chatsState.chats, sessionExpired]);
    // Check for new messages at regular intervals
    react_1.useEffect(() => {
        if (chatsState.runUpdateChatsTask && !sessionExpired) {
            ChatsUpdater_1.default.startNew(chatsState.chatsSyncedUpTo);
            return () => ChatsUpdater_1.default.stop();
        }
    }, [chatsState.runUpdateChatsTask, chatsState.chatsSyncedUpTo, sessionExpired]);
    // Mark current user as online at regular intervals
    react_1.useEffect(() => {
        var _a;
        if (((_a = usersState.me) === null || _a === void 0 ? void 0 : _a.userId) && !sessionExpired) {
            const markAsOnline = () => service_1.default.markAsOnline();
            const taskRunner = RecurringTaskRunner_1.default.startNew(markAsOnline, constants_1.MARK_CURRENT_USER_AS_ONLINE_INTERVAL_MS, false);
            return () => taskRunner.stop();
        }
    }, [(_b = usersState.me) === null || _b === void 0 ? void 0 : _b.userId, sessionExpired]);
    // Update user details at regular intervals
    const userIdsCount = usersState.userDictionary ? Object.keys(usersState.userDictionary).length : 0;
    react_1.useEffect(() => {
        if (usersState.userDictionary && !sessionExpired) {
            const updateUsers = () => {
                const updateUsersTask = dispatch(getUsers_1.default(Object.keys(usersState.userDictionary), usersState.usersSyncedUpTo));
                return updateUsersTask.finally(() => dispatch(updateMinutesSinceLastOnline_1.default()));
            };
            const taskRunner = RecurringTaskRunner_1.default.startNew(updateUsers, constants_1.UPDATE_USERS_INTERVAL_MS, true);
            return () => taskRunner.stop();
        }
    }, [userIdsCount, usersState.usersSyncedUpTo, sessionExpired]);
    // Each time the users in the selected chat change, attempt to make p2p connections to each user
    react_1.useEffect(() => {
        if (selectedChat && selectedChatUsersOnline.length && !sessionExpired) {
            RtcConnectionsHandler_1.default.setupMissingConnections(selectedChatUsersOnline);
        }
    }, [selectedChatUsersOnline.join(), sessionExpired]);
    // Poll for new p2p connection details at regular intervals, this could be responses to our connection offers or new
    // offers from other users trying to establish a p2p connection with us
    react_1.useEffect(() => {
        var _a;
        if (((_a = usersState.me) === null || _a === void 0 ? void 0 : _a.userId) && !sessionExpired) {
            const taskRunner = ExponentialBackoffRecurringTaskRunner_1.default.startNew(() => __awaiter(this, void 0, void 0, function* () {
                const newConnectionCount = yield RtcConnectionsHandler_1.default.getConnections();
                return newConnectionCount > 0;
            }), constants_1.REFRESH_P2P_CONNECTIONS_MIN_INTERVAL_MS, constants_1.REFRESH_P2P_CONNECTIONS_MAX_INTERVAL_MS, 1.2, ExponentialBackoffRecurringTaskRunner_1.StartOptions.TriggerTaskAndReturn);
            return () => taskRunner.stop();
        }
    }, [(_c = usersState.me) === null || _c === void 0 ? void 0 : _c.userId, sessionExpired]);
    react_1.useEffect(() => {
        const scavengeCache = () => __awaiter(this, void 0, void 0, function* () {
            yield CachingDataService_1.default.scavengeCache();
            //console.log(await navigator.storage.estimate());
        });
        const taskRunner = RecurringTaskRunner_1.default.startNew(scavengeCache, constants_1.SCAVENGE_CACHE_INTERVAL_MS, true);
        return () => taskRunner.stop();
    }, []);
}
exports.setupBackgroundTasks = setupBackgroundTasks;
